<template>
    <b-modal
        id="access-control-role-form-modal"
        v-model="visibleModel"
        :title="mode === 'create' ? '역할 추가' : '역할 수정'"
        size="md"
        hide-footer
    >
        <div class="modal-form-compact">
            <div class="form-group-compact">
                <label>역할 이름 *</label>
                <CarbonInput v-model="localForm.roleName" />
            </div>
            <div class="form-group-compact">
                <label>역할 코드 *</label>
                <CarbonInput v-model="localForm.roleCode" :disabled="mode === 'edit'" />
            </div>
            <div class="form-group-compact">
                <label>설명</label>
                <textarea v-model="localForm.remarks" class="input-compact" rows="2"></textarea>
            </div>
            <div class="form-group-compact">
                <label>정렬 순서</label>
                <CarbonInput v-model.number="localForm.sortOrder" type="number" />
            </div>
        </div>
        <div class="modal-footer-compact">
            <CarbonButton @click="$emit('input', false)">취소</CarbonButton>
            <CarbonButton variant="primary" @click="handleSave">저장</CarbonButton>
        </div>
    </b-modal>
</template>

<script>
import accessControlMixin from "../mixins/accessControlMixin";
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonInput from "../../common/CarbonInput.vue";

export default {
    name: "RoleFormModal",
    components: { CarbonButton, CarbonInput },
    mixins: [accessControlMixin],
    props: {
        value: { type: Boolean, default: false },
        mode: { type: String, default: "create" },
        form: {
            type: Object,
            default: () => ({
                roleName: "",
                roleCode: "",
                remarks: "",
                sortOrder: 0,
            }),
        },
    },
    computed: {
        visibleModel: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
    },
    data() {
        return {
            localForm: {
                roleName: "",
                roleCode: "",
                remarks: "",
                sortOrder: 0,
            },
        };
    },
    watch: {
        value(visible) {
            if (visible && this.form) {
                this.localForm = { ...this.form };
            }
        },
        form: {
            handler(val) {
                if (this.value && val) {
                    this.localForm = { ...val };
                }
            },
            deep: true,
        },
    },
    methods: {
        handleSave() {
            if (!this.localForm.roleName || !this.localForm.roleCode) {
                this.toastError("역할 이름과 역할 코드는 필수입니다.");
                return;
            }
            const payload = {
                roleName: this.localForm.roleName,
                remarks: this.localForm.remarks,
                sortOrder: this.localForm.sortOrder,
            };
            this.$emit("save", {
                payload,
                mode: this.mode,
                form: { ...this.localForm },
            });
        },
    },
};
</script>

<style scoped>
.modal-form-compact {
    padding: 10px;
}
.form-group-compact {
    margin-bottom: 14px;
}
.form-group-compact label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
}
.modal-footer-compact {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 10px;
    border-top: 1px solid #e2e8f0;
}
</style>
